import React from 'react';
import clsx from 'clsx';
import styles from './DefaultHeader.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { faPlus, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/V3/Button/Button';

interface HeaderProps {
    id?: string;
    title: string | JSX.Element | React.ReactNode;
    textBelowTitle?: string;
    buttonLabel?: string;
    onClick?: () => void;
    onBack?: () => void;
    className?: string;
    displayButton?: boolean;
    buttonIcon?: IconDefinition;
    tooltipOptions?: JSX.Element;
    leftContentClassName?: string;
    rightContentClassName?: string;

    customButton?: React.ReactNode;
}

export const DefaultHeader: React.FC<HeaderProps> = ({
    id,
    title,
    buttonLabel,
    onClick,
    onBack,
    className,
    displayButton,
    buttonIcon,
    tooltipOptions,
    leftContentClassName,
    rightContentClassName,
    textBelowTitle,
    customButton
}) => {
    return (
        <>
            <div
                className={clsx(styles.container, className, {
                    [styles.containerWithTextBelowTitle]: textBelowTitle
                })}
            >
                <div className={clsx(styles.leftContent, leftContentClassName)}>
                    <div className={styles.title}>
                        {onBack && (
                            <FontAwesomeIcon
                                className={styles.backIcon}
                                icon={faArrowLeft}
                                onClick={onBack}
                            />
                        )}
                        {title}
                    </div>
                    {textBelowTitle && (
                        <div className={clsx(styles.textBelowTitle, styles.hideOnMobile)}>{textBelowTitle}</div>
                    )}
                </div>
                <div className={clsx(styles.rightContent, rightContentClassName)}>
                    {customButton
                        ? customButton
                        : buttonLabel &&
                          displayButton && (
                              <Button
                                  id={id}
                                  leftIcon={buttonIcon}
                                  label={buttonLabel}
                                  onClick={onClick}
                              />
                          )}
                    {tooltipOptions && <div className={styles.tooltipOptions}>{tooltipOptions}</div>}
                </div>
            </div>
            {textBelowTitle && <div className={styles.textBelowTitle}>{textBelowTitle}</div>}
        </>
    );
};

export default DefaultHeader;
